import BaseURL from "./BaseURL";

const CallURL = {
  //common api
  tokenauth: BaseURL.nodeapi + "tokenauth",
  login: BaseURL.nodeapi + "login",
  resend_otp: BaseURL.nodeapi + "resend_otp",
  verify_otp: BaseURL.nodeapi + "verify_otp",
  load_fullname: BaseURL.nodeapi + "load_fullname",
  save_fullname: BaseURL.nodeapi + "save_fullname",
  load_my_profile: BaseURL.nodeapi + "load_my_profile",
  load_course_list: BaseURL.nodeapi + "load_course_list",
  load_course: BaseURL.nodeapi + "load_course",
  check_valid_course: BaseURL.nodeapi + "check_valid_course",
  load_topic_list: BaseURL.nodeapi + "load_topic_list",
  load_topic: BaseURL.nodeapi + "load_topic",
  check_valid_topic: BaseURL.nodeapi + "check_valid_topic",
  load_content_list: BaseURL.nodeapi + "load_content_list",
  load_content: BaseURL.nodeapi + "load_content",
  //admin api
  register_user: BaseURL.nodeapi + "register_user",
  isadmin: BaseURL.nodeapi + "isadmin",
  load_user_count: BaseURL.nodeapi + "load_user_count",
  load_user_list: BaseURL.nodeapi + "load_user_list",
  edit_acc_status: BaseURL.nodeapi + "edit_acc_status",
  edit_acc_device: BaseURL.nodeapi + "edit_acc_device",
  edit_acc_validity: BaseURL.nodeapi + "edit_acc_validity",
  edit_course_status: BaseURL.nodeapi + "edit_course_status",
  add_edit_course: BaseURL.nodeapi + "add_edit_course",
  edit_topic_status: BaseURL.nodeapi + "edit_topic_status",
  add_edit_topic: BaseURL.nodeapi + "add_edit_topic",
  edit_content_status: BaseURL.nodeapi + "edit_content_status",
  add_edit_content: BaseURL.nodeapi + "add_edit_content",
};

export default CallURL;
